import { render, staticRenderFns } from "./modele-astreintes-create-step4-publier.vue?vue&type=template&id=554834a0&scoped=true"
import script from "./modele-astreintes-create-step4-publier.vue?vue&type=script&lang=js"
export * from "./modele-astreintes-create-step4-publier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554834a0",
  null
  
)

export default component.exports